import type { I_Brand } from '@enable-tech/shared-types/modules/brand/backend/responses/schemas';
import type { E_LoyaltyCardStatus } from '@enable-tech/shared-types/modules/loyaltyProgram/common/backend/enums';
import type { SetStateAction } from 'preact/compat';
import type { Dispatch } from 'preact/hooks';
import type { JSX } from 'preact/jsx-runtime';

export enum E_WalletApp {
  APPLE_WALLET = 'apple_wallet',
  WALLET_PASSES = 'wallet_passes',
  GOOGLE_WALLET = 'google_wallet',
  ENABLE_WALLET = 'enable_wallet',
  UNKNOWN = 'unknown',
}

type T_WalletPassButtonText = {
  firstLine: string;
  secondLine?: string;
};

export interface I_WalletPassButtonProps extends JSX.HTMLAttributes<HTMLButtonElement> {
  logo?: string;
  text: T_WalletPassButtonText;
  filled?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export type T_AndroidWalletApp = Exclude<
  E_WalletApp,
  E_WalletApp.APPLE_WALLET | E_WalletApp.UNKNOWN
>;

export type T_LoyaltyProgramContextType = {
  isApple: boolean;
  isAndroid: boolean;
  enableWalletAvailable: boolean;
  googleWalletAvailable: boolean;
  walletPassesAvailable: boolean;
  brandName: string;
  brandData?: I_Brand;
  setBrandData: Dispatch<SetStateAction<I_Brand | undefined>>;
  qrCodeUrl?: string;
  setQrCodeUrl: Dispatch<SetStateAction<string | undefined>>;
  loyaltyCardStatus?: E_LoyaltyCardStatus;
  setLoyaltyCardStatus: Dispatch<SetStateAction<E_LoyaltyCardStatus | undefined>>;
  customerHasAddedLoyaltyCard: (status: E_LoyaltyCardStatus) => boolean;
  appliedCodes: string[];
  setAppliedCodes: Dispatch<SetStateAction<string[]>>;
  inapplicableCodes: string[];
  setInapplicableCodes: Dispatch<SetStateAction<string[]>>;
  collectionScopedCodes: string[];
  setCollectionScopedCodes: Dispatch<SetStateAction<string[]>>;
};

export interface I_WalletButtonsProps {
  logo?: string;
  text?: { firstLine: string; secondLine?: string };
  filled?: boolean;
  className?: string;
  onClick?: () => void;
  [key: string]: unknown;
}
